import { render, staticRenderFns } from "./AccreditationRequestsList.view.vue?vue&type=template&id=caf96408"
import script from "./AccreditationRequestsList.view.vue?vue&type=script&lang=js"
export * from "./AccreditationRequestsList.view.vue?vue&type=script&lang=js"
import style0 from "./AccreditationRequestsList.view.vue?vue&type=style&index=0&id=caf96408&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports